import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { IVInfusionsHero } from '../components/iv-infusions/IVInfusionsHero';
export function IVInfusionsPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2546">
      <Navigation data-id="element-2547" />
      <main data-id="element-2548">
        <IVInfusionsHero data-id="element-2549" />
      </main>
      <Footer data-id="element-2550" />
    </div>;
}